export default __webpack_public_path__ + "5f2132c162fc35decfd6ba99bf770c56.png";